// Global guard to refresh the application if a code-split chunk cannot be loaded.
// This mitigates the "Failed to fetch dynamically imported module" / "ChunkLoadError" issue
// that occurs when a user still has an old version of the main bundle after a new deploy.
//
// Simply import this module once (e.g. in src/main.tsx) – it patches the browser event
// listeners early in the page life-cycle.

/* eslint-disable no-console */

function shouldAutoReload(error: unknown): boolean {
  if (!error) return false;

  // Vite / SystemJS message
  if (typeof error === "string" && error.includes("Failed to fetch dynamically imported module")) {
    return true;
  }

  if (error instanceof Error) {
    // Webpack style message
    if (error.message.includes("ChunkLoadError")) return true;
    // General dynamic import failure
    if (error.message.includes("Loading chunk") && error.message.includes("failed")) return true;
  }

  return false;
}

// Listen for normal error events coming from failed <script type="module"> imports
window.addEventListener("error", (event) => {
  if (shouldAutoReload(event.message ?? event.error)) {
    console.warn("💡 Missing JS chunk detected – reloading the page to pull the latest version.");
    // Avoid infinite reload loops: only try once per tab
    sessionStorage.setItem("revenuehub-last-reload", Date.now().toString());
    window.location.reload();
  }
});

// Listen for rejected promises (dynamic import returns a promise)
window.addEventListener("unhandledrejection", (event) => {
  if (shouldAutoReload(event.reason)) {
    console.warn("💡 Missing JS chunk detected (promise rejection) – reloading the page.");
    sessionStorage.setItem("revenuehub-last-reload", Date.now().toString());
    window.location.reload();
  }
});

export {}; 